import { useState } from 'react'
import { Box } from '@mui/material'
import { Chat20Regular, Search20Regular } from '@/components/Icon'
import HomeNavPulseRow from './HomeNavPulseRow'
import HomeNavRecentSection from './HomeNavRecentSection.jsx'
import HomeNavSectionToggle from './HomeNavSectionToggle'
import HomeNavThreadRows from './HomeNavThreadRows'
import ThreadsSectionAllThreadsDialog from './ThreadsSectionAllThreadsDialog'
import styles from './HomeNavPane.module.scss'

/** The Chat half of the rail: actions, pinned threads, then recent threads. */
export default function HomeNavChatPane({ pinnedThreads, threads, allThreads, onNewChat, ...rowProps }) {
  const [searchOpen, setSearchOpen] = useState(false)
  const openSearch = () => setSearchOpen(true)

  return (
    <Box className={styles.pane}>
      <Box className={`${styles.group} ${styles.actionGroup}`}>
        <HomeNavPulseRow Icon={Chat20Regular} label="New Chat" onClick={onNewChat} />
        <HomeNavPulseRow Icon={Search20Regular} label="Search" onClick={openSearch} />
      </Box>
      <HomeNavSectionToggle title="Pinned" className={styles.pinnedContainer}>
        <HomeNavThreadRows
          threads={pinnedThreads}
          emptyNote="No pinned chats here"
          menuSurface="pinned"
          {...rowProps}
        />
      </HomeNavSectionToggle>
      <HomeNavRecentSection threads={threads} onSearch={openSearch} onShowMore={openSearch} {...rowProps} />
      <ThreadsSectionAllThreadsDialog
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        threads={allThreads ?? threads}
        {...rowProps}
      />
    </Box>
  )
}
